import { render, staticRenderFns } from "./ClubManagement.vue?vue&type=template&id=a1d540b4"
import script from "./ClubManagement.vue?vue&type=script&lang=js"
export * from "./ClubManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports